module.exports = __webpack_public_path__ + "static/media/qrcod.2518b234.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/invitation-page/qrcod.png
// module id = 792
// module chunks = 228